export default "__VITE_ASSET__a00c6749__"